import React, { Fragment, useRef, useState, useContext } from 'react'
import classnames from 'classnames'
import Popover from '@mui/material/Popover'
import MenuList from '@mui/material/MenuList'
import MenuItem from '@mui/material/MenuItem'
import ListItem from '@mui/material/ListItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Typography from '@mui/material/Typography'
import Divider from '@mui/material/Divider'
import Arrow from '@mui/icons-material/ArrowRight'
import withStyles from '@mui/styles/withStyles'
import ApplicationIcon from 'genesis-suite/icons/Application'
import { CloudContext } from './contexts/CloudContext'
import { AuthContext } from './contexts/AuthContext'

const styles = {
    arrow: {
        transition: 'transform .2s ease',
    },
    arrowDown: {
        transform: 'rotate(90deg)',
    },
}

const ContextController = ({ classes }) => {
    const [open, setOpen] = useState(false)
    const { actAs } = useContext(AuthContext)
    const { clouds, selectedCloud, changeCloud } = useContext(CloudContext)

    const anchor = useRef(null)
    const anchorOrigin = { vertical: 'bottom', horizontal: 'left' }
    const transformOrigin = { vertical: 'top', horizontal: 'left' }

    if (!clouds || clouds.length === 0) return null

    return (
        <Fragment>
            <ListItem
                button
                ref={anchor}
                onClick={() => setOpen(true)}
                title={selectedCloud}
                disabled={actAs ? true : false}
            >
                <ListItemIcon>
                    <ApplicationIcon htmlColor="#000" />
                </ListItemIcon>
                <ListItemText>{selectedCloud}</ListItemText>
                <Arrow className={classnames(classes.arrow, { [classes.arrowDown]: open })} />
            </ListItem>
            <Popover
                anchorEl={anchor.current}
                open={open}
                onClose={() => setOpen(false)}
                anchorOrigin={anchorOrigin}
                transformOrigin={transformOrigin}
            >
                <MenuList>
                    <ListItem>
                        <Typography variant="h6">Change Application</Typography>
                    </ListItem>
                    <Divider variant="middle" />
                    {clouds &&
                        clouds.map((cloud, i) => (
                            <MenuItem
                                key={cloud}
                                onClick={() => {
                                    changeCloud(i)
                                    setOpen(false)
                                }}
                            >
                                {cloud}
                            </MenuItem>
                        ))}
                </MenuList>
            </Popover>
        </Fragment>
    )
}

export default withStyles(styles)(ContextController)
